<!--
 * @des: 抽奖活动图片
 * @Author: nzj
 * @Date: 2022-09-02
-->
<template>
  <div class="contailner">
    <img src="../assets/img/spr.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'SurpriseImg',
  metaInfo: {
    title: '收货惊喜',
  },
}
</script>

<style lang="scss" scoped>
.contailner {
  width: 100%;
  height: 100vh;
  img {
    width: 100%;
  }
}
</style>
